import React, { useState, useEffect, useRef } from "react";
import "../../../styles/tableheader.css";

const TableHeader = ({ headers }) => {
  const headerRef = useRef(null);
  const [isCovered, setIsCovered] = useState(false);

  useEffect(() => {
    const checkOverlap = () => {
      if (!headerRef.current) return;

      const rect = headerRef.current.getBoundingClientRect();
      const isHidden = rect.top < 0 || rect.bottom < 50;

      setIsCovered(isHidden);
    };

    window.addEventListener("scroll", checkOverlap);
    window.addEventListener("resize", checkOverlap);
    checkOverlap();

    return () => {
      window.removeEventListener("scroll", checkOverlap);
      window.removeEventListener("resize", checkOverlap);
    };
  }, []);

  return (
    <thead
      ref={headerRef}
      className={`table-light text-center sticky-header ${
        isCovered ? "z-index-0" : "z-index-20"
      }`}
    >
      <tr>
        {headers.map((header, index) => (
          <th
            key={index}
            style={{ width: header.width ,textAlign:header.align||"center"}}
          >
            {header.title}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
